export default __webpack_public_path__ + "static/404-tablet-f568665748aa05ccda2d1c79eb5ba59f.webp";